import constants from '../constants/auth';
import { RECAPTCHA_STORAGE_KEY } from '../constants/storage';
import React from 'react';
import ReactDOM from 'react-dom';
import Recaptcha from '../components/Recaptcha';
import storage from '../services/storage';

abstract class BaseRecaptcha {
    ID: string;
    tokenResolve: any;

    constructor(id: string) {
        this.ID = id;
    }
}

export class MockRecaptcha extends BaseRecaptcha {
    callback = (token: string) => {};

    execute = async () => Promise.resolve('mock-recaptcha-token');

    unmount = () => {};

    render = () => {};

    getContainer = () => null;
}

export class GoogleRecaptcha extends BaseRecaptcha {
    grecaptcha: any;

    callback = (token: string) => {
        this.tokenResolve(token);
        // @ts-ignore
        window.grecaptcha.reset();
    };

    execute = async () => {
        const tokenPromise = new Promise<string>(resolve => {
            this.tokenResolve = resolve;
            try {
                // @ts-ignore
                window.grecaptcha.execute();
            } catch (error) {
                // console.error(error);
                /**
                 * In case the execute fails return an empty token
                 */
                resolve('');
            }
        });
        return tokenPromise;
    };

    getContainer = () => {
        const container = document.getElementById('recaptcha-container') as Element;
        return container;
    };

    unmount = () => {
        const container = this.getContainer();
        ReactDOM.unmountComponentAtNode(container);
    };

    render = () => {
        return new Promise((resolve, reject) => {
            try {
                const container = this.getContainer();
                ReactDOM.render(<Recaptcha callback={this.callback} />, container, () => {
                    storage.saveState(RECAPTCHA_STORAGE_KEY, true);
                    resolve(true);
                });
            } catch (error) {
                reject('UNABLE_TO_RENDER_RECAPTCHA');
            }
        });
    };
}

const googleRecaptchaService = new GoogleRecaptcha('recaptcha-service');
const mockRecaptchaService = new MockRecaptcha('mock-recaptcha-service');

export const getRecaptcha = () =>
    constants.RECAPTCHA_ENABLED !== 'false' ? googleRecaptchaService : mockRecaptchaService;
